import { useQuery } from "@tanstack/react-query";
import { fetchTeamScoresSummary } from "../services/functional_summaries";

const GetTeamScoreSummary = (patientId, startDate = null, endDate = null, providerIds = null) => {
  const getTeamScoreSummary = useQuery({
    queryKey: ["teamScoreSummary", patientId, startDate, endDate, providerIds],
    queryFn: () => fetchTeamScoresSummary(patientId, startDate, endDate, providerIds),
    enabled: !!patientId,
  });
  return getTeamScoreSummary;
};

export default GetTeamScoreSummary;
